import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import { VDataTable, VDataTableFooter, VDataTableServer } from 'vuetify/components/VDataTable'
import { VDatePicker } from 'vuetify/components/VDatePicker'
import { VSkeletonLoader } from 'vuetify/components/VSkeletonLoader'
import { VStepper } from 'vuetify/components/VStepper'
import { VFileUpload } from 'vuetify/labs/VFileUpload'

import defaults from './defaults'
import { icons } from './icons'
import theme from './theme'

// Styles
import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

export default createVuetify({
  aliases: {
    IconBtn: VBtn,
  },
  components: {
    VDataTable,
    VDataTableServer,
    VDataTableFooter,
    VSkeletonLoader,
    VDatePicker,
    VStepper,
    VFileUpload,
  },
  defaults,
  icons,
  theme,
})
